import React from 'react'

import { TabModeEnum } from '@components/Tabs/interface'
import SaleSummary from '@features/myWriting/pages/MyWritingPage/components/SaleSummary'
import { SHOW_EBOOK_FEATURE } from '@configs/config'
import { SaleAnalyticsOverview } from '../SaleAnalyticsOverview'
import { TabBody } from './components/TabsSelectSaleAnalytics/components/TabBody'
import { TabsSelectSaleAnalytics } from './components/TabsSelectSaleAnalytics'
import { PaymentReport } from '../PaymentReport'
import PaymentConditionTab from '../PaymentConditionTab/PaymentConditionTab'
import { SaleAnalyticsTabProps } from './interfaces'
import { EbookSaleAnalyticsOverview } from '../EbookSaleAnalyticsOverview'

function SaleAnalyticsTab({
  data,
  initialValues,
  startDate,
  endDate,
  queryParams,
  handleSearch,
  handleTabChange,
}: SaleAnalyticsTabProps) {
  return (
    <TabsSelectSaleAnalytics
      className='mobile:mx-[20px] mobile:mb-0'
      borderBottomClassName='mobile:w-[calc(100%-40px)]'
      initialTabs={
        SHOW_EBOOK_FEATURE
          ? [
              { tabId: 'overview', name: 'ภาพรวม' },
              { tabId: 'ebook', name: 'ภาพรวมอีบุ๊ก' },
              { tabId: 'sale-report', name: 'สรุปรายงานการขาย' },
              {
                tabId: 'payment-report',
                name: 'รายงานการจ่ายเงิน',
              },
              { tabId: 'agreement-payment', name: 'ข้อตกลง และการจ่ายเงิน' },
            ]
          : [
              { tabId: 'overview', name: 'ภาพรวม' },
              { tabId: 'sale-report', name: 'สรุปรายงานการขาย' },
              {
                tabId: 'payment-report',
                name: 'รายงานการจ่ายเงิน',
              },
              { tabId: 'agreement-payment', name: 'ข้อตกลง และการจ่ายเงิน' },
            ]
      }
      onActiveTabChange={handleTabChange}
      mode={TabModeEnum.LINE}
    >
      <TabBody tabId='overview'>
        <SaleAnalyticsOverview
          data={data}
          initialValues={initialValues}
          startDate={startDate}
          endDate={endDate}
          queryParams={queryParams}
          handleSearch={handleSearch}
        />
      </TabBody>
      {SHOW_EBOOK_FEATURE && (
        <TabBody tabId='ebook'>
          <EbookSaleAnalyticsOverview />
        </TabBody>
      )}
      <TabBody tabId='sale-report'>
        <SaleSummary />
      </TabBody>
      <TabBody tabId='payment-report'>
        <PaymentReport />
      </TabBody>
      <TabBody tabId='agreement-payment'>
        <PaymentConditionTab />
      </TabBody>
    </TabsSelectSaleAnalytics>
  )
}

export default SaleAnalyticsTab
